import React from "react";
import {appHelpers} from "../../_helpers";
import PageEmptyContent from "../utils/page.empty-content";
import ServerPaginatedTable from "../utils/pagination.server";

const AuditTrailTableStructure = ({data, interpretUserId, interpretAirline, pageIndex, interpretAirport}) => {
    return (data.length === 0) ?
    (<PageEmptyContent message='No record match your search!' />) :

(
    <div className="view">
    <table className="table table-striped table-hover fixed">
        <thead>
        <tr>
            <th style={{width:"72px"}}>
                <span>S/N</span>
            </th>
            <th style={{width:"32%"}}>
                <span>User</span>
            </th>
            <th>
                <span>Created Date</span>
            </th>
            <th>
                <span>Action</span>
            </th>
            <th style={{width:"30%"}}>
                <span>Description</span>
            </th>
        </tr>
        </thead>
        <tbody>
        {data.map((record, i) =>
            <tr  key={i}>
            <td className="text-capitalize">{ `${pageIndex + i + 1}`  }</td>
            <td>{record.UserName}</td>
            <td className="text-capitalize">{`${appHelpers.formatDate(record.CreatedDate)}`}</td>
            <td className="text-capitalize">{record.AuditActionName}</td>
            <td className="text-capitalize">{record.Description}</td>
        </tr>)}
        </tbody>
    </table>
    </div>
)
};
class AuditTrailRecords extends React.Component {
    render() {
        let {interpretAirline, interpretAirport, interpretUserId, currentPage, pageDataCallback, pageSize, totalCount, records } = this.props;
        let pageIndex = (currentPage - 1) * pageSize;
        return (
            <ServerPaginatedTable currentPage={currentPage} fetchMore={pageDataCallback} target={<AuditTrailTableStructure  data={records} interpretAirport={interpretAirport} interpretAirline={interpretAirline} interpretUserId={interpretUserId} pageIndex={pageIndex}/>}
             pageSize={pageSize} totalCount={ totalCount }/>
        )
    }
}
export default AuditTrailRecords;



// WEBPACK FOOTER //
// ./src/views/audit-trail/audit-table.js